import { getFormattedDate } from '@/utils/date/getFormattedDate';
import { SampleDetailsPageSection } from './SampleDetailsPageSection';
import { useGetSampleDetailsQuery } from '@viome/viome-base/src/usecase/Misc/MiscQuery';
import { useUserStore } from '@/hooks/useUserStore';

export interface SampleDetailsPageCustomerSectionProps
  extends React.ComponentProps<'div'> {
  isLoading?: boolean;
  sampleId?: string;
  'data-testid'?: string;
}

export const SampleDetailsPageCustomerSection = ({
  isLoading,
  sampleId,
  'data-testid': testId,
  ...rest
}: SampleDetailsPageCustomerSectionProps) => {
  const { data: samples } = useGetSampleDetailsQuery();
  const { user: userData } = useUserStore();
  const currentSample = samples?.find(
    (sample) => sample.sample_information.sample_id === sampleId,
  );
  const customerDetails = currentSample?.customer_details;

  const allCustomerData = [
    {
      label: 'Customer Name',
      value: userData?.fullName || customerDetails?.name,
    },
    {
      label: 'DOB',
      value: getFormattedDate(customerDetails?.dob),
    },
    {
      label: 'Gender',
      value: customerDetails?.gender,
    },
    {
      label: 'Customer ID',
      value: userData?.userID,
    },
  ];

  const customerData = allCustomerData.filter(
    (item) =>
      item.value !== null && item.value !== undefined && item.value !== '',
  );

  return (
    <SampleDetailsPageSection
      {...rest}
      title="Customer Information"
      data={customerData}
      isLoading={isLoading}
      data-testid={testId}
    />
  );
};
